"use client";
import {
  ICompanySubMenu,
  MenuItemType,
} from "@/api/AppApi/services/company/interfaces/ICompany";
import CommonDropdownMenu from "./CommonDropdownMenu";
import MenuLink from "./MenuLink";
interface Props {
  item: ICompanySubMenu & { onClick?: () => void };
  isMobile: boolean;
  down: boolean;
  isFooter?: boolean;
  dropdown?: boolean;
  toggle?: boolean;
  title?: boolean | string;
  autoClose?: boolean;
  innerMenuClassName?: string;
}

const getLink = (item: ICompanySubMenu) => {
  const { type, value, title, slug } = item ?? {};

  const navigationSlug = slug ?? value;
  switch (type) {
    case MenuItemType.category:
      return value == "0"
        ? item.parentId
          ? "/categories/" + item.parentId
          : "/categories"
        : "/categories/" + navigationSlug;
    case MenuItemType.brand:
      return "/brands/" + navigationSlug;
    case MenuItemType.contact_us:
      return "/contact-us?title=" + title;
    case MenuItemType.inner_page:
      return "/inner-pages/" + value;
    case MenuItemType.blogs:
      return "/blog";
    default:
      return "";
  }
};
interface GetLinkProps {
  isMobile: boolean;
  href: string;
  title: any;
  isFooter?: boolean;

  autoClose?: boolean;
}

const GetLink: React.FC<GetLinkProps> = ({
  isMobile,
  href,
  title,
  isFooter,

  autoClose = true,
}) => {
  return (
    <MenuLink
      isMobile={isMobile}
      href={href}
      title={title}
      isFooter={isFooter}
      autoClose={autoClose}
    />
  );
};

const MenuItem: React.FC<Props> = ({
  item,
  isMobile,
  down,
  isFooter,
  dropdown = true,
  toggle = true,
  title = true,
  autoClose = true,
  innerMenuClassName,
}) => {
  if (item.sub_menu && item.sub_menu.length === 0)
    return (
      <div
        onClick={() => {
          item.onClick && item.onClick();
        }}
      >
        <GetLink
          isMobile={isMobile}
          href={getLink(item)}
          title={{ text: item.title }}
          isFooter={isFooter}
          autoClose={autoClose}
        />
      </div>
    );
  return (
    <CommonDropdownMenu
      down={down}
      isMobile={isMobile}
      title={{
        text: title ? item.title : undefined,
        className: innerMenuClassName,
      }}
      isFooter={isFooter!}
      dropdown={dropdown}
      toggle={toggle}
    >
      {item.sub_menu?.map((child, key) => (
        <MenuItem
          key={key}
          item={child}
          isMobile={isMobile}
          down={false}
          isFooter={isFooter}
          autoClose={child.type !== MenuItemType.more}
          innerMenuClassName={"pc-menu-title-gap"}
        />
      ))}
    </CommonDropdownMenu>
  );
};

export default MenuItem;
